import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const InvitePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // URL에서 초대 코드 추출
    const inviteCode = searchParams.get('code');
    
    if (inviteCode) {
      // 세션 스토리지에 초대 코드 저장 (회원가입 시까지 유지)
      sessionStorage.setItem('referralCode', inviteCode);
      console.log('초대 코드 저장됨:', inviteCode);
    }
    
    // 온보딩 페이지로 리다이렉트
    navigate('/onboarding', { replace: true });
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Pretendard',
      fontSize: '16px',
      color: '#666'
    }}>
      친구 초대를 받으셨군요! 잠시만 기다려주세요 처리중입니다
    </div>
  );
};

export default InvitePage;
